var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHelpActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2250",
    "data-name": "Group 2250",
    transform: "translate(-30 -377)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_80",
    "data-name": "Ellipse 80",
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    transform: "translate(30 377)",
    fill: "#FCE3E7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2238",
    "data-name": "Group 2238",
    transform: "translate(-567.035 -1455.133)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3556",
    "data-name": "Path 3556",
    d: "M609.989,1843.99a1.972,1.972,0,0,0,1.027-1.743,1.692,1.692,0,0,0-1.775-1.837,1.848,1.848,0,0,0-1.806,2.024,3.466,3.466,0,0,0,.062.623l-1.432.156c-.016-.311-.031-.545-.031-.747a3.16,3.16,0,0,1,3.222-3.331,2.929,2.929,0,0,1,3.1,3.051,3.362,3.362,0,0,1-1.65,2.864c-.654.5-1.276.934-1.37,1.868h-1.058v-.125A3.306,3.306,0,0,1,609.989,1843.99Zm-1.09,3.985a1.028,1.028,0,1,1-1,1.027A.982.982,0,0,1,608.9,1847.974Z",
    stroke: "#FC0057"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpActive);
export default __webpack_public_path__ + "static/media/help-active.05b51235164e5c801553628074306f57.svg";
export { ForwardRef as ReactComponent };